const buildEnv = process.env.REACT_APP_BUILD_ENV === 'dev' ? 'dev' : 'prod'

const env = buildEnv === 'dev'
  ? require('./env.dev.js')
  : require('./env.prod.js')

module.exports = { ...env, buildEnv }
